import Vue from "vue";
import Antd from 'ant-design-vue';
import App from "./App.vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index';
import i18n from "./assets/lang/i18n";
import './assets/style/main.scss'
import 'ant-design-vue/dist/antd.css'; // or 'ant-design-vue/dist/antd.less'
import device from 'current-device';
// import 'lib-flexible/flexible'
// import '@/plugins/fontSize'
// import '@/plugins/flexible'
// document.title="博鳌"
Vue.use(ElementUI);
Vue.use(Antd)
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
